import React from "react"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgBuilding02 } from "@digits-shared/components/SVGIcons/line/Building02.svg"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

const MissingPartyBox = styled.div`
  width: 30px;
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px dashed ${colors.translucentSecondary60};
  border-radius: 4px;
`

const MissingIcon = styled(SvgBuilding02)`
  width: 12px;
  height: 12px;
  border-radius: 4px;
  ${svgPathStyles(colors.translucentSecondary60)};
`

export const MissingPartyIcon: React.FC<{ className?: string }> = ({ className }) => (
  <MissingPartyBox className={className}>
    <MissingIcon />
  </MissingPartyBox>
)
